import React, { useEffect, useState } from "react";
import { AsyncSelect } from "@caelor/ui";
import {
  findUsersByName,
  getProfilePictureUrl,
  getUserByAccountId,
} from "../../../api/confluence-api";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
const Image = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
`;
const Name = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.text.text};
`;
const StyledLabel = ({ name, pictureUrl }) => {
  return (
    <Wrapper>
      <Image src={pictureUrl} />
      <Name>{name}</Name>
    </Wrapper>
  );
};
function mapUser(user) {
  return {
    avatarUrl: getProfilePictureUrl(user.profilePicture.path),
    id: user.accountId,
    name: user.publicName,
    type: "user",
    label: (
      <StyledLabel
        name={user.publicName}
        pictureUrl={getProfilePictureUrl(user.profilePicture.path)}
      />
    ),
    value: user.accountId,
  };
}
const ContributorsPicker = ({
  initialAccountIDs,
  onUpdate,
  isMulti,
  placeholder,
}) => {
  const { t } = useTranslation();
  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    if ((initialAccountIDs ?? []).length > 0) {
      const promises = [];
      for (const accountId of initialAccountIDs) {
        promises.push(getUserByAccountId(accountId));
      }
      Promise.all(promises)
        .then((res) => {
          setSelectedUsers(res.map((r) => mapUser(JSON.parse(r.body))));
        })
        .catch((e) => {});
    } else {
      setSelectedUsers([]);
    }
  }, [initialAccountIDs]);

  const loadOptions = async (query) => {
    try {
      const response = await findUsersByName(query);
      const data = JSON.parse(response.body);
      const atlassianUsers = data.results
        .filter(({ user }) => user.accountType === "atlassian")
        .map(({ user }) => mapUser(user));
      return atlassianUsers;
    } catch (error) {
      return [];
    }
  };

  return (
    <AsyncSelect
      isSearchable
      placeholder={placeholder || t("filter-by-people")}
      isClearable
      onChange={(e) => {
        if (e === undefined) {
          setSelectedUsers([]);
          onUpdate(isMulti ? [] : undefined);
          return;
        }
        if (isMulti) {
          setSelectedUsers(e);
          onUpdate(e.map((u) => u.id));
          return;
        }
        setSelectedUsers([e]);
        onUpdate(e);
      }}
      value={selectedUsers}
      isMulti={isMulti}
      loadOptions={loadOptions}
    />
  );
};
export default ContributorsPicker;
